// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__changelog__ChangeLogContentHeader__root","left":"CentricUI__changelog__ChangeLogContentHeader__left","right":"CentricUI__changelog__ChangeLogContentHeader__right"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/changelog/ChangeLogContentHeader.css
// module id = 1759
// module chunks = 10